import React from "react";
import "./RenderResponse.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import StickyHeadTable from "../StickyHeadTable/StickyHeadTable.js";
import PieChart from "../../utils/ProbabilityPiechart.js";
import StatisticsPiechart from "../../utils/StatisticsPiechart.js";
const classname = [
  "rejected-bg",
  "rejected-heading",
  "rejected-text",
  "success-bg",
  "success-heading",
  "success-text",
];
const data = [
  { value: 5, name: "A" },
  { value: 10, name: "B" },
  { value: 15, name: "C" },
  { value: 20, name: "D" },
];
const probability = 20;

let v = 0;
const RenderResponse = (props) => {
  const {
    results,
    state = "",
    languages = [],
    feedback,
    max_similarity,
  } = props;
  // console.log(state, languages);
  // console.log(results);
  console.log(max_similarity);

  const data = results.map((eachType) => ({
    name: eachType.check_type,
    value: eachType.similar_titles.length,
  }));
  const renderRejection = (status, reason = "this is rejlsjf") => {
    if (status === "passed") return <p className="success-text">{reason}</p>;
    return <p className="rejected-text">{reason}</p>;
  };
  const renderResult = (checkType) => {
    const { check_type, similar_titles, status } = checkType;
    let similar_titles2 = similar_titles.filter((title) => {
      if (state === "") {
        if (languages?.length === 0) {
          return true;
        } else {
          //write logic for language
          return true;
        }
      } else if (state === title.State.toLowerCase()) {
        if (languages?.length === 0) {
          return true;
        } else {
          //write logic for language
          return true;
        }
      }
    });
    // console.log(check_type === "Guideline Violations");
    if (
      check_type === "Spelling Variations" ||
      check_type === "Semantic Similarity" ||
      check_type === "Language Agnostic"
    ) {
      similar_titles2 = similar_titles.map((eachItem) => ({
        ...eachItem,
        Title_Name:
          eachItem["Title_Name"] +
          " (" +
          Math.floor(eachItem["Similarity_Score"]) +
          ")",
      }));
      similar_titles2.sort(
        (a, b) => b["Similarity_Score"] - a["Similarity_Score"]
      );
    }

    return (
      <li className="check-container" key={v++}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            {check_type === "Guideline Violations" && (
              <span
                className={`table-heading ${
                  status === "passed" ? classname[5] : classname[1]
                }`}
              >
                {check_type}
              </span>
            )}
            {check_type !== "Guideline Violations" && (
              <span
                className={`table-heading ${
                  status === "passed" ? classname[5] : classname[1]
                }`}
              >
                {check_type} : {similar_titles2?.length}
              </span>
            )}
          </AccordionSummary>
          <AccordionDetails>
            {check_type === "Guideline Violations" &&
              renderRejection(status, checkType?.reason)}
            {check_type !== "Guideline Violations" && (
              <StickyHeadTable similar_titles={similar_titles2} />
            )}
          </AccordionDetails>
        </Accordion>
      </li>
    );
  };
  return (
    <div className="response-container">
      <div className="piecharts-container">
        <div className="piecharts-statistics">
          <h3>Statistics</h3>
          <StatisticsPiechart data={data} />
        </div>
        <div className="probability-score-container">
          <h1>Similarity Score: {Math.floor(max_similarity)}%</h1>
          <PieChart percentage={Math.floor(max_similarity)} />
        </div>
      </div>
      <div className="genai-report">
        <h3>Gen AI Report</h3>
        <p>{feedback}</p>
        {/* <p>{max_similarity}</p> */}
      </div>

      <ul>{results.map((eachType) => renderResult(eachType))}</ul>
    </div>
  );
};
export default RenderResponse;
